import {
  createMuiTheme,
  darken,
  responsiveFontSizes,
} from '@material-ui/core/styles';

const theme = createMuiTheme({
  font: {
    regular: 'proxima_novaregular',
    medium: 'proxima_novamedium',
    bold: 'proxima_novabold',
    light: 'proxima_novalight',
    semiBold: 'proxima_novasemibold',
    secondary: 'Lato',
  },
  name: 'Blue Panther',
  palette: {
    background: {
      sidebarActiveItem: '#F5F6FA',
      defaultLightGrey: '#F5F6FA',
      primary: {
        light: '#00a8ff29',
        main: darken('#00a8ff29', 0.2),
        dark: darken('#00a8ff29', 0.4),
      },
      warning: {
        light: '#fff17633',
        main: darken('#fff17633', 0.2),
        dark: darken('#fff17633', 0.4),
      },
      error: {
        light: '#e5737333',
        main: darken('#e5737333', 0.2),
        dark: darken('#e5737333', 0.4),
      },
    },
    primary: {
      light: '#65bffb',
      main: '#00a8ff',
      dark: '#4476fd',
    },
    secondary: {
      light: '#65bffb',
      main: '#00a8ff',
      dark: '#4476fd',
    },
    link: {
      enabled: '#2779f6',
    },
    type: 'dark',
  },
  typography: {
    fontFamily: 'proxima_novaregular',
    button: {
      textTransform: 'none',
    },
  },
  spacing: 4,
});

export default responsiveFontSizes(theme);
